<template>
  <div class="select-modal">
    <container-loader v-if="isLoading && !$store.getters.isLoading" />
    <div class="vertical-flow pb-4">
      <div class="listing-header columns is-flex-vcenter mb-0">
        <div class="img-picker-aspect column is-3">
          <span class="is-flex is-flex-vcenter">
            <h4 class="title">Logo:</h4>
            <b-icon
              icon="information"
              size="is-small"
              v-tippy
              :title="$t('aviso-proporcao-img')"
            />
          </span>

          <div class="img-picker">
            <ImgPicker
              ref="imgPicker"
              :logourl="clienteInfo.logoUrl"
              @uploadedFiles="getLogo"
              @alert="showMessageImg"
              :title="''"
              :customMaxImageWidth="500"
              :customMinImageWidth="250"
              :customMaxImageHeight="500"
              :customMinImageHeight="250"
              :dataImage="{
                largura: '500',
                altura: '500',
                size: '2MB',
              }"
            />
          </div>
        </div>

        <div class="is-flex is-flex-wrap is-100 is-flex-vcenter">
          <div class="is-flex is-100 h-max-content">
            <div class="group-search column is-flex is-10">
              <v-input
                ref="nomeInput"
                :title="'nome-loja-b2b'"
                class="is-100"
                v-model="clienteInfo.b2bNome"
                :required="true"
              />
            </div>

            <div
              class="header-buttons column is-flex is-flex-vbottom mr-3 is-2"
            >
              <button
                v-if="permissao.update"
                @click="save()"
                :disabled="isSaving"
                class="save-btn is-100 is-flex is-flex-vcenter is-flex-hcenter"
                type="button"
              >
                {{ $t("salvar") }}
                <button-loader :isSaving="isSaving" />
              </button>
            </div>
          </div>

          <div class="is-flex is-100 h-max-content">
            <div class="column is-flex is-flex-vbottom is-6">
              <vss-select
                ref="paletaInput"
                :id="1"
                class="is-100"
                title="padrao-cores"
                :value="paletaSelecionada"
                :options="paletas"
                :loading="LoadingPaleta"
                @search="carregarCores"
                @input="atualizarPaleta"
                label="descricao"
                searchable
                :closeOnSelect="true"
                :required="true"
              />

              <button
                v-if="permissao.delete"
                @click="promptChangeSituacao"
                class="btn btn-custom-size delete-color"
                type="button"
                :disabled="!paletaSelecionada"
                :class="{ 'hover-effect': paletaSelecionada }"
              >
                <b-icon icon="delete" type="is-white"> </b-icon>
              </button>

              <button
                v-if="permissao.update"
                @click="showModalEditarCor"
                class="btn btn-custom-size"
                type="button"
                :disabled="!paletaSelecionada"
              >
                <b-icon icon="pencil" type="is-white"> </b-icon>
              </button>

              <button
                v-if="permissao.create"
                @click="showModalInserirCor"
                class="btn btn-custom-size"
                type="button"
              >
                <b-icon icon="plus" type="is-white"> </b-icon>
              </button>
            </div>
          </div>
          <div class="is-flex is-100 h-max-content">
            <div class="column is-flex is-flex-vbottom is-6">
              <vss-select
                ref="agrupamentoInput"
                :id="2"
                class="is-100"
                :mlLabels="translate"
                title="agrupamento-produtos-loja-b2b"
                :value="valorSelecionadoAgrupamento"
                :options="agrupamentosFields"
                :loading="loadingParametros"
                @search="carregarParametroAgrupamento"
                @input="atualizarParametroAgrupamento"
                label="key"
                :closeOnSelect="true"
                :required="false"
              />
            </div>
            <div class="column is-flex is-flex-vbottom is-6">
              <vss-select
                ref="ordenacaoInput"
                :id="3"
                class="is-100"
                :mlLabels="translate"
                title="ordenacao-produtos-loja-b2b"
                :value="valorSelecionadoOrdenacao"
                :options="ordenacaoFields"
                :loading="loadingParametros"
                @search="carregarParametroOrdenacao"
                @input="atualizarParametroOrdenacao"
                label="key"
                :closeOnSelect="true"
                :required="false"
              />
            </div>
          </div>
        </div>
      </div>

      <span class="is-flex is-flex-vcenter">
        <h4 class="title">{{ $t("descricao-empresa-b2b") }}</h4>
      </span>
      <VueEditor v-model="clienteInfo.descricao" />

      <b-modal
        :active.sync="showModalCor"
        @close="fecharModal"
        :width="'520px'"
      >
        <div class="bg">
          <CoresModal
            @fecharModal="fecharModal"
            @updatePaletaSelecionada="clienteInfo.b2bColorsId = $event"
            :paletaSelecionada="paletaSelecionada"
          />
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import ContainerLoader from "@/components/content/loader/ContainerLoader";
import B2BParametrizacoesValidation from "@/services/validations/b2b/B2BParametrizacoesValidation";
import B2BClienteSovisService from "@/services/b2b/B2BClienteSovisService";
import B2BCoresService from "@/services/b2b/B2BCoresService";
import CoresModal from "@/components/b2b/parametrizacoes/modal/CoresModal";
import ImgPicker from "@/components/shared/form/ImgPicker";
import { VueEditor } from "vue2-editor";

export default {
  components: {
    ContainerLoader,
    ImgPicker,
    CoresModal,
    VueEditor,
  },
  data() {
    return {
      translate: true,
      permissao: {},
      isLoading: false,
      LoadingPaleta: false,
      isSaving: false,
      paletas: [],
      paletaSelecionada: null,
      debouncedOnSearch: null,
      showModalCor: false,
      clienteInfo: {
        clienteSovisId: null,
        logoUrl: "",
        b2bNome: "",
        descricao: "",
        b2bColorsId: null,
      },
      parametroAgrupamento: "AGRUPAMENTO_PRODUTOS_LOJA",
      parametroOrdenacao: "ORDENACAO_PRODUTOS_LOJA",
      loadingParametros: false,
      orderingParams: null,
      groupingParams: null,
      valorSelecionadoOrdenacao: null,
      valorSelecionadoAgrupamento: null,
      agrupamentosFields: [
        { key: "padrao", valor: "0" },
        { key: "categoria", valor: "1" },
        { key: "linhaproduto", valor: "2" },
        { key: "familia", valor: "3" },
      ],
      ordenacaoFields: [
        { key: "ordenacao-nome-produto", valor: "0" },
        { key: "ordenacao-codigo-produto", valor: "1" },
        { key: "ordenacao-valor-produto", valor: "2" },
        { key: "ordenacao-sequencia-apresentacao", valor: "3" },
      ],
      mediaFile: null,
      b2bClienteSovisService: new B2BClienteSovisService(
        this.$http,
        this.$router
      ),
      coresService: new B2BCoresService(this.$http, this.$router),
    };
  },
  created() {
    this.permissao = this.hasPermissionAccess(
      "b2b",
      "b2b-parametrizacoes-edit"
    );

    if (!this.permissao.read) {
      this.$router.push({
        name: "acesso-nao-permitido",
        params: { tela: "dados-iniciais" },
      });
    } else {
      this.carregarDados();
    }
    this.validation = new B2BParametrizacoesValidation(this.$root.msgs);
    this.debouncedOnSearch = this.debounce(this.onSearch, 500);
  },
  methods: {
    carregarParametroOrdenacao() {
      this.carregarParametros(this.parametroOrdenacao, "ordering");
    },
    carregarParametroAgrupamento() {
      this.carregarParametros(this.parametroAgrupamento, "grouping");
    },
    atualizarParametroOrdenacao(valor) {
      this.valorSelecionadoOrdenacao = valor.key;
      this.orderingParams.valor = valor.valor;
    },
    atualizarParametroAgrupamento(valor) {
      this.valorSelecionadoAgrupamento = valor.key;
      this.groupingParams.valor = valor.valor;
    },
    carregaParametroSelecionado(parametros, tipo) {
      if (tipo === "ordering") {
        this.valorSelecionadoOrdenacao = this.ordenacaoFields.find(
          (ordenacao) => ordenacao.valor === parametros.valor
        );
      }
      if (tipo === "grouping") {
        this.valorSelecionadoAgrupamento = this.agrupamentosFields.find(
          (agrupamento) => agrupamento.valor === parametros.valor
        );
      }
    },

    carregarParametros(tipoParametro, tipo) {
      this.loadingParametros = true;
      this.$axios
        .get(`/b2b/parametros/nome/${tipoParametro}.json`)
        .then((response) => {
          this.isEmpty = response.data.content.length <= 0;
          if (!this.isEmpty) {
            if (tipo === "ordering") {
              this.orderingParams = response.data.content;
              this.carregaParametroSelecionado(this.orderingParams, tipo);
            } else if (tipo === "grouping") {
              this.groupingParams = response.data.content;
              this.carregaParametroSelecionado(this.groupingParams, tipo);
            }
          }
        })
        .catch((e) => {
          this.isEmpty = true;
          this.$root.showMessage("error", "msg-erro-dados-geral");
          this.loadingParametros = false;
        })
        .finally(() => {
          this.loadingParametros = false;
        });
    },
    onSearch(value) {
      this.carregarDados(this.removeToSearch(value));
    },
    carregarDados() {
      this.b2bClienteSovisService
        .find(this.$store.state.user.idClienteSovis)
        .then(({ content }) => {
          if (content && typeof content === "object") {
            this.clienteInfo = {
              clienteSovisId: null,
              logoUrl: "",
              b2bNome: "",
              descricao: "",
              b2bColorsId: null,
              ...content,
            };
            this.isEmpty = false;
          } else {
            this.clienteInfo = {
              clienteSovisId: null,
              logoUrl: "",
              b2bNome: "",
              descricao: "",
              b2bColorsId: null,
            };
            this.isEmpty = true;
          }
        })
        .catch((e) => {
          this.isEmpty = true;
          this.clienteInfo = {
            clienteSovisId: null,
            logoUrl: "",
            b2bNome: "",
            descricao: "",
            b2bColorsId: null,
          };
          this.$root.showMessage("error", "msg-erro-dados-geral");
        });
    },
    carregarCores(searchQuery) {
      this.LoadingPaleta = true;

      this.coresService
        .findAllCombo(searchQuery)
        .then(this.mapCores)
        .then((mappedContent) => {
          this.paletas = mappedContent;

          this.paletaSelecionada = this.paletas.find(
            (paleta) => paleta.id === this.clienteInfo.b2bColorsId
          );
        })
        .catch((e) => {
          this.$root.showMessage("error", "msg-erro-dados-geral");
        })
        .finally((_) => {
          this.LoadingPaleta = false;
        });
    },
    atualizarPaleta(valor) {
      this.paletaSelecionada = valor;
    },
    mapCores(response) {
      return response.content.map(({ id, descricao }) => ({
        id,
        descricao,
        label: descricao,
      }));
    },
    save() {
      if (
        this.validation.validate(
          this.clienteInfo,
          this.paletaSelecionada,
          this.$refs
        )
      ) {
        this.isSaving = true;
        Promise.all([
          this.saveClientInfo(),
          this.saveOrderingParams(),
          this.saveGroupingParams(),
        ])
          .then((results) => {
            this.$root.showMessage("success", "msg-sucesso-cliente-sovis");
          })
          .catch((error) => {
            (this.orderingParams = null),
              (this.groupingParams = null),
              this.$root.showMessage("error", "msg-erro-dados-geral");
          })
          .finally(() => {
            this.isSaving = false;
          });
      }
    },
    saveOrderingParams() {
      if (this.orderingParams.idB2bParametro) {
        return this.$axios.post(
          `/b2b/parametros/update/${this.orderingParams.idB2bParametro}`,
          this.orderingParams
        );
      } else {
        return Promise.resolve();
      }
    },
    saveGroupingParams() {
      if (this.groupingParams.idB2bParametro) {
        return this.$axios.post(
          `/b2b/parametros/update/${this.groupingParams.idB2bParametro}`,
          this.groupingParams
        );
      } else {
        return Promise.resolve();
      }
    },
    saveClientInfo() {
      const requestData = {
        ...this.clienteInfo,
        b2bColorsId: this.paletaSelecionada.id,
      };
      return this.b2bClienteSovisService.save(this.mediaFile, requestData);
    },
    promptChangeSituacao() {
      let message = this.$t("msg-confirmacao-desativacao-n", {
        n: this.paletaSelecionada.descricao,
      });

      this.$root.confirm({
        message: message,
        onConfirm: this.inativarPaleta,
      });
    },
    inativarPaleta() {
      this.coresService
        .updateSituacao(this.paletaSelecionada)
        .then((response) => {
          this.$root.showMessage("success", "msg-sucesso-ao-desativar-cor");
        })
        .catch((error) => {
          this.$root.showMessage("error", "msg-erro-dados-geral");
        })
        .finally((_) => {
          this.carregarCores();
          this.paletaSelecionada = null;
        });
    },
    fecharModal() {
      this.showModalCor = false;
      this.carregarCores();
    },
    showModalEditarCor() {
      this.showModalCor = !this.showModalCor;
    },
    showModalInserirCor() {
      this.paletaSelecionada = null;
      this.showModalCor = !this.showModalCor;
    },
    showMessageImg(type, msg) {
      this.$root.showMessage(type, msg);
    },
    getLogo(imagens) {
      if (imagens.length > 0) {
        const { imgurl, file } = imagens[0];

        this.mediaFile = file;
        this.clienteInfo.logoUrl = imgurl;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-custom-size {
  padding: 0.35rem;
  height: max-content;
  margin: 0 0 12px 8px;
}

.img-picker {
  width: 225px;
  height: 251px;
}

.img-picker-aspect {
  aspect-ratio: 1 / 1;
  max-width: 250px;
}

.h-max-content {
  height: max-content;
}

.title {
  font-size: 12px;
  color: $darker-gray-color;
  font-weight: 600;
  margin-bottom: 0;
  text-transform: capitalize;
  padding-bottom: 2px;
  padding-top: 0px;
}

.delete-color[disabled] {
  background-color: #c0342a;
}
.delete-color {
  background-color: #f44336;
}
.hover-effect:hover {
  background-color: #f35d52;
}
</style>
